import { jsx as l } from "react/jsx-runtime";
const r = (e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ...e,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 3h2v9.595l-1.5.402V4.5h-5V13h5v-.002l.402 1.502H4V3h2v-.75h4V3ZM6.617 6.615l1.85-.516v1.355l.916-.245-1.226 3.89-.62-1.822-.92.247V6.616Z",
        clipRule: "evenodd"
      }
    )
  }
);
export {
  r as Battery
};
